import { CreateEmailTemplateMeta, CreateEmailTemplatePayload } from 'types/store/CreateEmailTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { createEmailTemplateActions } from '../actions';

export default createAsyncReducer<CreateEmailTemplateMeta, CreateEmailTemplatePayload>(createEmailTemplateActions);
